export default {"src":"/_next/static/media/Compass.219444e8.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};